module.exports = __webpack_public_path__ + "siwk-cover.654bc287253ca7bfa4cbb54e8f8ec853.png";